import { Component } from '@angular/core';
import { soundpostOrderEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Orders') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostorder-form',
    templateUrl: './soundpostorder.form.component.html'
})
export class soundpostOrderFormComponent extends BaseFormComponent {
    public record!: soundpostOrderEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'ordersPreviousVersionID', sectionName: 'Orders (Previous Version ID)', isExpanded: false },
            { sectionKey: 'ordersOriginalOrderID', sectionName: 'Orders (Original Order ID)', isExpanded: false },
            { sectionKey: 'orderLines', sectionName: 'Order Lines', isExpanded: false }
        ]);
    }
}

